
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Form, Icon, Input, Button, Spin, Alert, Row, Col, Divider, Layout, Modal, Descriptions } from 'antd';
import './login.css';
import { history } from '../../container/History';
import * as actions from '../../actions';
import { bindActionCreators } from 'redux';
import GoogleLogin from 'react-google-login';
import { connect } from 'react-redux';
import base64 from 'base-64'
// import ReCAPTCHA from "react-google-recaptcha";
import AppleLogin from 'react-apple-login'
import AppleId from '../Inc/appleId';
import NESAFooter from '../Inc/NESAFooter'
import momenttimezone from 'moment-timezone'
import moment from 'moment'


const MaintenanceStartDate = momenttimezone.tz("2023-02-04 19:59:00", "America/Chicago").format('YYYY-MM-DD HH:mm:ss')
const MaintenanceEndDate = momenttimezone.tz("2023-02-04 23:01:00", "America/Chicago").format('YYYY-MM-DD HH:mm:ss')
const CurrentTime = momenttimezone.tz(moment(), 'America/Chicago').format('YYYY-MM-DD HH:mm:ss')
let today = moment().format('YYYY-MM-DD')

const { Footer } = Layout;

const FormItem = Form.Item;
const MYST_URL = process.env.REACT_APP_MYST_API;
const DIRECTORY_URL = process.env.REACT_APP_DIRECTORY
const LoadingIcon = <Icon type="loading" style={{ fontSize: 48, color: 'white' }} spin />;
// const ReCAPTCHA_ENABLED = process.env.REACT_APP_RECAPTCHA_ENABLED == "true" ? true : false
const ReCAPTCHA_ENABLED = false
// Google's official multi-color "G" mark, used verbatim across "Sign in with
// Google" buttons per Google's branding guidelines.
const GoogleIcon = (
    <svg width="20" height="20" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.8741 2.6836-6.615z" />
        <path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.8591-3.0477.8591-2.3446 0-4.3282-1.5831-5.036-3.7104H.9573v2.3318C2.4382 15.9832 5.4818 18 9 18z" />
        <path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573C.3477 6.1732 0 7.5477 0 9s.3477 2.8268.9573 4.0418L3.964 10.71z" />
        <path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.4259 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6555 3.5795 9 3.5795z" />
    </svg>
);
class AccountCreationForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            icon: 'fa fa-eye',
            type: 'password',
            returnURL: '',
            loginDisabled: true,
            activeSocialProvider: null,
            checkingSession: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.loading = this.loading.bind(this);
        this.showHide = this.showHide.bind(this);
    }

    showHide(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            type: this.state.type === 'input' ? 'password' : 'input',
            icon: this.state.icon === 'fa fa-eye-slash' ? 'fa fa-eye' : 'fa fa-eye-slash'
        })
    }

    handleChange(event) {
        let name = event.target.name
        this.setState({ [name]: event.target.value });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                // Explicit manual login overrides any prior explicit logout,
                // and this session isn't SSO-origin.
                localStorage.removeItem('directoryLoggedOut');
                localStorage.removeItem('viaSso');
                this.props.actions.login(values.userName, values.password, this.state.returnURL);
            }
        });
    }

    loading() {
        if (this.props.loggingIn) {
            return <Button loading className="loginButton" type="primary">logging In..</Button>;
        } else {
            if (ReCAPTCHA_ENABLED)
                return <Button disabled={this.state.loginDisabled} type="primary" htmlType="submit" className="loginButton"> LOGIN </Button>;
            return <Button type="primary" htmlType="submit" className="loginButton"> LOGIN </Button>;
        }
    }

    setReturnURL = (returnURL) => {
        this.setState({
            returnURL: returnURL
        })
    }

    componentDidMount = () => {
        this._isMounted = true;
        //server Maintenance
        let loggedinUser = JSON.parse(localStorage.getItem('user'))
        if(loggedinUser) {
            let personGUID = loggedinUser.personGuid;
            this.props.actions.getProfileInfo(personGUID)
        }
        
        if (moment(CurrentTime).isSameOrAfter(MaintenanceStartDate) && moment(CurrentTime).isSameOrBefore(MaintenanceEndDate)) {
            Modal.warning({
                className: 'server-maintenance',
                title: 'Scouting America’s Spark Alumni Directory will be down for Maintenance',
                centered: 'centered',
                content: (
                    <div>
                        <p>Scouting America’s Spark Alumni Directory will be down for scheduled maintenance on Saturday, February 4, 2023 between 10pm - 12pm CST. We apologize for the inconvenience.</p>

                        <span><b>Start Date: </b>February 4, 2023 08:00 PM</span> <br></br>
                        <span><b>End Date: </b>February 4, 2023 10:00 PM</span>

                    </div>
                )
            });
        }

        if (this.props.location.search) {
            const urlParams = new URLSearchParams(this.props.location.search)
            let returnurl = urlParams.get('returnurl')
            let session = urlParams.get('session')
            this.setReturnURL(returnurl)
            if (session) {
                let SessionValue = base64.decode(session);
                localStorage.setItem('user', SessionValue)
                localStorage.setItem('viaSso', 'true')
                // A fresh explicit SSO handoff overrides any prior explicit logout.
                localStorage.removeItem('directoryLoggedOut')
            }
        }
        if (this.props.location.search && localStorage.getItem('user')) {
            const urlParams = new URLSearchParams(this.props.location.search)
            let returnurl = urlParams.get('returnurl')
            history.push('/' + returnurl)
            localStorage.setItem("panelView", JSON.stringify("adminTabView"))
        }
        else if (localStorage.getItem('user')) {
            if (localStorage.getItem('viaSso') === 'true') {
                // A local SSO session exists - Root.componentDidMount already
                // re-validates it via /refresh on this page load (it runs for
                // every route, not just '/'), so there's nothing to do here.
                // Avoids calling /refresh twice when '/' itself is reloaded.
            } else {
                // A local non-SSO (manual/social login) session exists. Root only
                // re-validates via /refresh for viaSso sessions, so without this,
                // a full reload landing on '/' (e.g. clearing the address bar down
                // to the bare domain) left an already-logged-in user stranded on
                // the Login form instead of returning them to their dashboard.
                // checkingSession swaps in a spinner in the meantime so the login
                // form doesn't flash on screen while the redirect resolves. On
                // success redirectDashboard() navigates away and unmounts this
                // page, but on failure (e.g. expired token) it stays here and
                // shows its own error modal/logout - so checkingSession must be
                // reset back once the call settles, or the spinner is stuck
                // forever after the modal is closed.
                this.setState({ checkingSession: true });
                this.props.actions.redirectDashboard().then(() => {
                    if (this._isMounted) {
                        this.setState({ checkingSession: false });
                    }
                });
            }
        }
        else if (localStorage.getItem('directoryLoggedOut') === 'true') {
            // Skip /refresh only for the single Login mount that immediately
            // follows a logout, to avoid the still-active SSO session on the
            // other site silently logging the user back in. Consume the flag
            // right away so a page reload after this starts fresh and /refresh
            // works normally again.
            localStorage.removeItem('directoryLoggedOut')
        }
        else {
            // No local session and no session query param - this is the actual
            // "landing on Login" case, so check for an existing SSO session via
            // the httpOnly auth cookie. Scoped here (not Root) so it only runs
            // when the Login page itself mounts, not on every page's hard refresh.
            //
            // document.referrer tells us whether the browser navigated here from
            // the other site (MYST_URL) - if so, a failed /refresh is worth
            // surfacing as an error. A direct visit (no referrer, or a referrer
            // from somewhere else) should fail silently and just show the login form.
            let cameFromSSO = false
            if (document.referrer) {
                try {
                    cameFromSSO = new URL(document.referrer).hostname === new URL(MYST_URL).hostname
                } catch (e) {
                    cameFromSSO = false
                }
            }
            this.props.actions.refreshSession(cameFromSSO)
        }
        const { protocol, hostname } = window.location;
        this.appleId = new AppleId();
        this.appleId.loadSDK()
            .then(() => {
                this.appleId.init({
                    clientId: 'org.scouting.my',
                    scope: 'name email',
                    redirectURI: `${protocol}//${hostname}`,
                    usePopup: true,
                }, this.onAppleIdSuccess, this.onAppleIdFailure);
            });
    }

    onAppleIdSuccess = (data) => {
        this.setState({ activeSocialProvider: 'apple' });
        this.props.actions.loginUserWithApple(data.detail.authorization.id_token)
    }

    handleAppleSignIn = () => {
        if (window.AppleID && window.AppleID.auth) {
            window.AppleID.auth.signIn();
        }
    }

    componentWillUnmount = () => {
        this._isMounted = false;
        if (this.appleId) {
            this.appleId.cleanUp();
        }
    }

    CaptchaonChange = (value) => {
        this.setState({
            loginDisabled: false
        })
        console.log("Captcha value:", value);
    }

    renderLogInFooter = () => {
        return <div className='nesa-footer' style={{ padding: '0px 20px 0px 20px' }}>
            <Footer style={{ padding: '0px 20px 0px 20px' }} >
                <ul className='social-link' style={{ paddingBottom: '0px', paddingTop: '0px' }}>
                    <li className="cursor" style={{ fontSize: '14px' }}><a target="_blank" href="https://www.facebook.com/ScoutingAlumniOfficial"><i className="fa fa-facebook fa-2x" aria-hidden="true"></i></a></li>
                    <li className="cursor"><a target="_blank" href="https://www.instagram.com/scoutingalumniofficial/"><i className="fa fa-instagram fa-2x" aria-hidden="true"></i></a></li>
                    {/* <li className="cursor" style={{ fontSize: '14px' }}><a target="_blank" href="https://twitter.com/nesabsa"><i className="fa fa-twitter fa-2x" aria-hidden="true"></i></a></li>
                    <li className="cursor" style={{ fontSize: '14px' }}><a target="_blank" href=" https://www.youtube.com/channel/UCWm1A2BiXdJl8jR9YV_2idw"><i className="fa fa-youtube fa-2x" aria-hidden="true"></i></a></li> */}
                </ul>

                <span>© {moment().format('YYYY')} Scouting Alumni – All Rights Reserved</span>

                <ul style={{ paddingBottom: '0px'}} >
                    <li className="cursor" style={{ fontSize: '14px' }}><a target="_blank" href="https://scoutingalumni.org/about/">About</a></li>
                    <li className="cursor" style={{ fontSize: '14px' }}><a target="_blank" href="https://nesa.org/resources/faq-2/">FAQ</a></li>
                    <li className="cursor" style={{ fontSize: '14px' }}><a target="_blank" href="https://scoutingalumni.org/about/contact-us/"> Contact </a></li>
                    < br className="visible-xs" />
                    <li className="cursor" style={{ fontSize: '14px' }}><a target="_blank" href="https://www.scouting.org/legal/terms-and-conditions/">Terms</a></li>
                    <li className="cursor" style={{ fontSize: '14px' }}><a target="_blank" href="https://www.scouting.org/legal/privacy-policy/">Privacy Policy</a></li><br className="visible-xs" />
                    <li className="cursor" style={{ fontSize: '14px' }}><a target="_blank" href="https://www.scouting.org/legal/donor-privacy-policy/">Donor Policy </a></li> <br className="visible-xs" />

                </ul>

            </Footer>
        </div>
    }

    render() {
        if (this.state.checkingSession) {
            return (
                <div className='flex-center' style={{ height: '100vh' }}>
                    <Spin size="large" tip="Loading..." />
                </div>
            );
        }
        const { getFieldDecorator } = this.props.form;
        const { protocol, hostname } = window.location;
        const responseGoogle = (response) => {
            if (response.profileObj) {
                var res = response.profileObj
                this.setState({ activeSocialProvider: 'google' });
                this.props.actions.loginUserWithGoogle(response);
            }
        }
        return (
            <div>
                <div className='page-container'>
                    <div className='registration-page'>
                        <Row type='flex'>
                                <Col className='side-left'>
                                    <div className='content-text' // style={{ paddingBottom: '0px' }}
                                    >
                                        <h1>
                                            <span>Welcome to</span>
                                            <img className='spark-text-image' src="../spark-text-image.png" />
                                            {/* <span className='spark-text'>Sp
                                                <img className='' src='./' /> rk</span> */}
                                        </h1>

                                        <div className='content-text-subheader'>
                                            The directory of Scouting Alumni
                                            </div>
                                        <div className="subtitle">
                                            <span>
                                                Creating a Scouting Alumni Directory account connects you to the friends you made, the memories you share, and the adventures that helped shape the person you are today.
                                                Sign up today to update your profile so your fellow alumni can find you and you can reconnect with the friends you miss
                                                </span>
                                            <span style={{ display: 'block' }}>
                                                ---- perhaps around the campfire
                                                </span>
                                        </div>
                                        <Button onClick={() => window.location.assign(`${MYST_URL}/create-account?redirectUrl=${DIRECTORY_URL}/?returnurl=` + this.state.returnURL)} className='account-btn' >CREATE ACCOUNT</Button>
                                        {/* {this.renderLogInFooter()} */}
                                        <NESAFooter />
                                    </div>
                                </Col>
                                <Col className='side-right'>
                                    <div className='mainContent loginPanel'>
                                        {this.props.timeout ? (
                                            <Alert
                                                className='SessionWarningMsg'
                                                message="Session Timeout"
                                                description="Your session is expired. login again to continue."
                                                type="warning"
                                                showIcon
                                            />) : null
                                        }
                                        <Form onSubmit={this.handleSubmit} className="login-form">
                                            <div className='loginContent'>
                                                <div className='loginForm'>
                                                    <img className='loginImage' src="../Scouting Alumni_LogoIcons_Blue.png" alt="BSA LOGO" />
                                                    <h1>Login to Alumni Directory
                                                        <span className='login-note'>Using your My.Scouting login</span>
                                                    </h1>

                                                    <span className='label'>Username</span>
                                                    <FormItem>
                                                        {getFieldDecorator('userName', {
                                                            rules: [{ required: true, message: 'Enter your username!' }],
                                                        })(
                                                            <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
                                                        )}
                                                    </FormItem>
                                                    <span className='label'>Password</span>
                                                    <FormItem>
                                                        {getFieldDecorator('password', {
                                                            rules: [{ required: true, message: 'Enter your Password!' }],
                                                        })(
                                                            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} suffix={<i className={this.state.icon} style={{ cursor: 'pointer' }} onClick={this.showHide} ></i>} type={this.state.type} placeholder="Password" />
                                                        )}
                                                    </FormItem>
                                                    {/* {ReCAPTCHA_ENABLED && <Row type='flex'>
                                                        <Col span={24}>
                                                            <ReCAPTCHA type="image" sitekey="6LdT4WsUAAAAAHcJ2NDOCPNJkHemvsJSx4rZaWyq" onChange={this.CaptchaonChange} />
                                                        </Col>
                                                    </Row>} */}
                                                    <FormItem>
                                                        {this.loading()}
                                                    </FormItem>

                                                    <a className='forgot-password' onClick={() => window.location.assign(`${MYST_URL}/recover-credentials`)}> Forgot username / password? </a>

                                                    <div className='visible-xs visible-sm visible-md'>
                                                        <Button onClick={() => window.location.assign(`${MYST_URL}/create-account?redirectUrl=${DIRECTORY_URL}/?returnurl=` + this.state.returnURL)} className='account-btn' >CREATE ACCOUNT</Button>
                                                    </div>
                                                </div>
                                                <Divider>OR</Divider>
                                                <Row className='m-t-20 social-login-row' gutter={12}>
                                                    <Col sm={24} md={12} lg={12}>
                                                        <GoogleLogin
                                                            clientId="364170442919-3teb9cg74dt5583vog2brqvnhu8qlkd5.apps.googleusercontent.com"
                                                            onSuccess={responseGoogle}
                                                            onFailure={responseGoogle}
                                                            cookiePolicy={'single_host_origin'}
                                                            render={renderProps => (
                                                                <button
                                                                    type="button"
                                                                    className="social-login-btn google-login-btn"
                                                                    onClick={renderProps.onClick}
                                                                    disabled={renderProps.disabled || (this.props.loading && this.state.activeSocialProvider === 'google')}
                                                                >
                                                                    <span className="social-login-icon">{GoogleIcon}</span>
                                                                    <span className="social-login-text">Sign in with Google</span>
                                                                    <span className="social-login-trailing">
                                                                        {this.props.loading && this.state.activeSocialProvider === 'google' ?
                                                                            <Spin size="small" />
                                                                            :
                                                                            <i className="fa fa-chevron-right" />
                                                                        }
                                                                    </span>
                                                                </button>
                                                            )}
                                                        />
                                                    </Col>
                                                    <Col sm={24} md={12} lg={12}>
                                                        <button
                                                            type="button"
                                                            className="social-login-btn apple-login-btn"
                                                            onClick={this.handleAppleSignIn}
                                                            disabled={this.props.loading && this.state.activeSocialProvider === 'apple'}
                                                        >
                                                            <i className="fa fa-apple social-login-icon" />
                                                            <span className="social-login-text">Sign in with Apple</span>
                                                            <span className="social-login-trailing">
                                                                {this.props.loading && this.state.activeSocialProvider === 'apple' ?
                                                                    <Spin size="small" />
                                                                    :
                                                                    <i className="fa fa-chevron-right" />
                                                                }
                                                            </span>
                                                        </button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Form>

                                    </div>

                                </Col>
                            </Row>

                            <div>
                            </div>
                        </div>
                    </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        loggingIn: state.authenticationReducer.loggingIn,
        timeout: state.authenticationReducer.timeout,
        loading: state.redirectingreducer.loading,
        profileinfo: state.profilereducer.profileinfo,
        profileloading: state.profilereducer.loading
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}


const AccountCreation = Form.create()(AccountCreationForm);
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(AccountCreation);


// WEBPACK FOOTER //
// ./src/components/Login/index.js